"use client";

import Image from "next/image";

const CDN = process.env.NEXT_PUBLIC_CDN_STATIC_URL;

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    icon: `${CDN}social-icon/facebook.svg`,
    bg: "#3b5998",
    href: (url: string, _title: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    width: 12,
    height: 12,
  },
  {
    label: "X",
    icon: `${CDN}social-icon/x.svg`,
    bg: "#29aae1",
    href: (url: string, title: string) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
    width: 18,
    height: 18,
  },
  {
    label: "WhatsApp",
    icon: `${CDN}social-icon/whatsapp.svg`,
    bg: "#4caf50",
    href: (url: string, _title: string) =>
      `https://wa.me/?text=${encodeURIComponent(url)}`,
    width: 18,
    height: 18,
  },
];

interface NewsSocialShareProps {
  url?: string;
  title?: string;
}

const NewsSocialShare = ({ url, title = "" }: NewsSocialShareProps) => {
  const shareUrl =
    url || (typeof window !== "undefined" ? window.location.href : "");

  const handleShare = (href: string) => {
    window.open(href, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="flex items-center gap-4">
      {/* Share Button */}
      <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 transition">
        <Image
          src={`${CDN}social-icon/social-share.svg`}
          alt="social-share-icon"
          title="social-share-icon"
          width={18}
          height={18}
          unoptimized
          aria-hidden="true"
          className="invert"
        />
        Share
      </button>

      {/* Social Icons */}
      <div className="flex items-center gap-3">
        {SOCIAL_LINKS.map(({ label, icon, bg, href, width, height }) => (
          <button
            key={label}
            onClick={() => handleShare(href(shareUrl, title))}
            aria-label={`Share on ${label}`}
            className="w-10 h-10 rounded-full flex items-center justify-center cursor-pointer border-0 outline-none"
            style={{ backgroundColor: bg }}
          >
            <Image
              src={icon}
              alt={label}
              title={label}
              width={width}
              height={height}
              unoptimized
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default NewsSocialShare;
